var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.componentKey, attrs: { id: "webapp" } },
    [
      _c("DialogView"),
      _vm._v(" "),
      _vm.showSupport ? _c("SupportView") : _vm._e(),
      _vm._v(" "),
      _vm.webPushAvailable
        ? _c(
            "div",
            { staticClass: "webPushSoftAsk" },
            [_c("WebPushSoftAskView")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "moduleWrapper" } },
        [
          _vm.loading
            ? _c("div", { attrs: { id: "framework" } }, [
                _c("div", { attrs: { id: "appload" } }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 32 32",
                        width: "64",
                        height: "64",
                      },
                    },
                    [
                      _c("circle", {
                        staticClass: "animation-spinner",
                        attrs: {
                          id: "spinner",
                          cx: "16",
                          cy: "16",
                          r: "14",
                          fill: "none",
                        },
                      }),
                    ]
                  ),
                ]),
              ])
            : _c("RouterView"),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "uploadButton" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }